import client from './client';

const Ankets = {
  getAnkets() {
    return client.get('/ankets');
  },
};

export default Ankets;
